const findMissingLoadNumber = (array) => {
  function findMissingNumbers(arr) {
    let fullArr = Array.from({ length: Math.max(...arr) }, (_, i) => i + 1);
    let missingNumber = fullArr.find((num) => !arr.includes(num));
    return missingNumber;
  }

  const numbersArray = array.map((element) =>
    Number(element.match(/\d+/)?.[0])
  );
  let missingNums = findMissingNumbers(numbersArray.filter(Number));
 // const newElement = missingNums?.[0];

  return missingNums;
};
export {findMissingLoadNumber}